"use client";

import React, { useState } from 'react';

import { getSimplifiedUser } from '../actions/getCurrentUserSimplified';
import ClientOnly from '../components/ClientOnly';
import Hero from '../components/grow-on-x/Hero';
import SocialProof from '../components/grow-on-x/SocialProof';
import WhatYoullLearn from '../components/grow-on-x/WhatYouLearn';
import WhyDifferent from '../components/grow-on-x/WhyDifferent';
import Demo from '../components/grow-on-x/Demo';
import PriceSection from '../components/grow-on-x/Pricing';
import PeerQuikPromo from '../components/grow-on-x/PeerQuikPromo';
import FAQ from '../components/grow-on-x/FAQ';
import axios from 'axios';
import { loadStripe } from '@stripe/stripe-js';

const GrowOnXLanding: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handlePurchase = async () => {
    setIsLoading(true);
    
    try {
      const stripe = await loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY!);
      
      const response = await axios.post("/api/stripe/checkout", { 
        plan: "grow-on-x"
      });
      
      const { sessionId } = response.data;
      await stripe!.redirectToCheckout({ sessionId });
    } catch (error: any) {
      console.error('Payment error:', error);
      const errorMessage = error.response?.data?.error || "Failed to initiate checkout. Please try again.";
      alert(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black">
      <Hero onPurchase={handlePurchase} isLoading={isLoading} />
      <SocialProof />
      <WhatYoullLearn />
      <WhyDifferent />
      {/* <Demo /> */}
      <PriceSection onPurchase={handlePurchase} isLoading={isLoading} />
      <PeerQuikPromo />
      <FAQ />
      
      {/* Footer CTA */}
      <section className="bg-gradient-to-t from-gray-900 to-black text-white py-16 px-4">
        <div className="max-w-2xl mx-auto text-center">
          <h3 className="text-3xl font-bold mb-6">Ready to grow on X?</h3>
          <button
            onClick={handlePurchase}
            disabled={isLoading}
            className={`bg-cyan-400 hover:bg-cyan-300 text-black font-bold py-4 px-12 rounded-lg text-xl transition-all transform hover:scale-105 shadow-lg shadow-cyan-400/50 ${
              isLoading ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            {isLoading ? 'Processing...' : 'Get the PDF – $9.99'}
          </button>
          <p className="text-sm text-gray-400 mt-4">
            <s className="text-gray-500">$29.99</s> — Launch price ends soon
          </p>
        </div>
      </section>
    </div>
  );
};

export default GrowOnXLanding;